import { NavLink } from 'react-router-dom';
import Icon from './Icon.jsx';
import s from './TabBar.module.css';

export default function TabBar({ items = [] }) {
  return (
    <nav className={s.bar} aria-label="Primary">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `${s.tab} ${isActive ? s.active : ''}`}
        >
          <Icon name={item.icon} size="md" />
          <span className={s.label}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
